// Config panel for the "check_time" condition block
import React from 'react';
import {
  Box,
  TextField,
  Typography
} from '@mui/material';

const CheckTimeConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    onSummaryChange(`${updated.startTime || '??:??'} – ${updated.endTime || '??:??'}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Checks if the current time is within a time window.
        Branches TRUE if inside the window, FALSE otherwise.
        Supports overnight ranges (e.g. 22:00 – 06:00).
      </Typography>

      <TextField
        size="small"
        label="Start Time"
        type="time"
        value={config.startTime || ''}
        onChange={(e) => handleChange('startTime', e.target.value)}
        InputLabelProps={{ shrink: true }}
        required
      />

      <TextField
        size="small"
        label="End Time"
        type="time"
        value={config.endTime || ''}
        onChange={(e) => handleChange('endTime', e.target.value)}
        InputLabelProps={{ shrink: true }}
        required
      />

      <TextField
        size="small"
        label="Timezone"
        value={config.timezone || 'Europe/Brussels'}
        onChange={(e) => handleChange('timezone', e.target.value)}
        helperText="IANA timezone (default: Europe/Brussels)"
      />
    </Box>
  );
};

export default CheckTimeConfig;
